import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faMapMarkedAlt,
  faUser,
  faList,
} from "@fortawesome/free-solid-svg-icons";
import logo from "../../assets/logo.png";

const Navbar = () => {
  const redirect = () => {
    window.location.href = "/";
  };

  const redirectToProfile = () => {
    window.location.href = "/profile";
  };

  const redirectToTracking = () => {
    window.location.href = "/tracking";
  };

  const redirectToMap = () => {
    window.location.href = "/sites";
  };
  return (
    <nav className="bg-gray-800 p-4 flex justify-between items-center">
      <div className="flex items-center">
        <img src={logo} alt="Company Logo" className="h-8" onClick={redirect} />
      </div>
      <div className="flex space-x-4">
        <FontAwesomeIcon
          icon={faList}
          className="text-white h-5 w-5 px-4"
          onClick={redirectToTracking}
        />
        <FontAwesomeIcon
          icon={faMapMarkedAlt}
          className="text-white h-5 w-5 px-4"
          onClick={redirectToMap}
        />
        <FontAwesomeIcon
          icon={faUser}
          className="text-white h-5 w-5 px-4"
          onClick={redirectToProfile}
        />
      </div>
    </nav>
  );
};

export default Navbar;
